import type { PinnedVersionDropdownRow } from "./types";

import ReleaseLabel from "@/components/ReleaseLabel";

export const PinnedVersionSelectRowContent = ({ row }: { row: PinnedVersionDropdownRow }) => {
  switch (row.kind) {
    case "latest":
      return (
        <span className="inline-flex items-center gap-1.5 text-xs italic text-muted-foreground">
          <span>Latest</span>
          {row.versionNumber > 0 && (
            <span className="text-muted-foreground/60">(Version {row.versionNumber})</span>
          )}
        </span>
      );
    case "label":
      return (
        <span className="inline-flex items-center gap-1.5">
          <ReleaseLabel
            label={{ id: row.labelId, name: row.labelName }}
            readOnly
            showDeleteButton={false}
          />
          <span className="text-muted-foreground">(Version {row.versionNumber})</span>
        </span>
      );
    case "version":
      return <span>Version {row.versionNumber}</span>;
    default:
      return null;
  }
};
